import type { PreContractIntakeForm } from './preContractTypes';

export type SolarDesignRevision = 'ai' | 'manual';

export function solarLayoutSignature(
    form: Pick<PreContractIntakeForm, 'roofModuleLayouts' | 'roofSelections'>,
): string {
    const layouts = form.roofModuleLayouts.map((layout) => ({
        roofIndex: layout.roofIndex,
        roofTagId: layout.roofTagId,
        moduleOrientation: layout.moduleOrientation,
        modules: layout.modules.map((cell) =>
            cell
                ? {
                      id: cell.id,
                      included: cell.included,
                      solarAccess: cell.solarAccess,
                  }
                : null,
        ),
    }));
    return JSON.stringify({
        layouts,
        selections: form.roofSelections,
    });
}

export function isSolarLayoutModifiedFromBaseline(
    form: Pick<PreContractIntakeForm, 'roofModuleLayouts' | 'roofSelections'>,
    baselineSignature: string | null,
): boolean {
    if (!baselineSignature) return false;
    return solarLayoutSignature(form) !== baselineSignature;
}
